module.exports = __webpack_public_path__ + "28eac2ad6e057d5ce5362c61222c96ef.pdf";